// extracted by mini-css-extract-plugin
var _1 = "SlashCommandMenu-module__dropzone--I4ihS";
var _2 = "SlashCommandMenu-module__icon--SCiyW";
var _3 = "SlashCommandMenu-module__tooltipTarget--sXFPa";
export { _1 as "dropzone", _2 as "icon", _3 as "tooltipTarget" }
